import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MainButton } from '@/components/ui/Button/Button';
import { toNextPromoReward } from '@/redux/reducers/shopReducer';
import { useAppDispatch } from '@/redux/store';

const ClaimPromoCodeReward: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onClick = (): void => {
    dispatch(toNextPromoReward());
  };

  return (
    <MainButton
      onClick={onClick}
      className="max-w-[10.625rem] mb-5"
      text={t('Claim')}
    />
  );
};

export { ClaimPromoCodeReward };
